var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9259 0H14.8609C6.98864 0 0.606934 6.38171 0.606934 14.2539V14.319C0.606934 22.1912 6.98864 28.5729 14.8609 28.5729H14.9259C22.7982 28.5729 29.1799 22.1912 29.1799 14.319V14.2539C29.1799 6.38171 22.7982 0 14.9259 0Z",
    fill: "url(#paint0_linear_3324_3006)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3144 5.8125H10.4731C8.03054 5.8125 6.04346 7.79958 6.04346 10.2421V18.3306C6.04346 20.7732 8.03054 22.7603 10.4731 22.7603H19.3144C21.7569 22.7603 23.744 20.7732 23.744 18.3306V10.2421C23.744 7.79958 21.7569 5.8125 19.3144 5.8125ZM7.6061 10.2421C7.6061 8.66149 8.89244 7.37514 10.4731 7.37514H19.3144C20.895 7.37514 22.1814 8.66149 22.1814 10.2421V18.3306C22.1814 19.9113 20.895 21.1976 19.3144 21.1976H10.4731C8.89244 21.1976 7.6061 19.9113 7.6061 18.3306V10.2421Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8938 18.4047C17.1651 18.4047 19.0141 16.5568 19.0141 14.2844C19.0141 12.012 17.1661 10.1641 14.8938 10.1641C12.6214 10.1641 10.7734 12.012 10.7734 14.2844C10.7734 16.5568 12.6214 18.4047 14.8938 18.4047ZM14.8938 11.7277C16.3042 11.7277 17.4514 12.8749 17.4514 14.2854C17.4514 15.6959 16.3042 16.8431 14.8938 16.8431C13.4833 16.8431 12.3361 15.6959 12.3361 14.2854C12.3361 12.8749 13.4833 11.7277 14.8938 11.7277Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3958 10.8317C20.0074 10.8317 20.506 10.3341 20.506 9.72149C20.506 9.10885 20.0084 8.61133 19.3958 8.61133C18.7832 8.61133 18.2856 9.10885 18.2856 9.72149C18.2856 10.3341 18.7832 10.8317 19.3958 10.8317Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3324_3006",
    x1: 4.78131,
    y1: 24.3986,
    x2: 25.0055,
    y2: 4.17538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DD2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#9537B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515BD4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.a52f717e7279e5ff42fa691b55150007.svg";
export { ForwardRef as ReactComponent };